import { render, staticRenderFns } from "./ThinkFarm.vue?vue&type=template&id=07c15748&scoped=true"
import script from "./ThinkFarm.vue?vue&type=script&lang=js"
export * from "./ThinkFarm.vue?vue&type=script&lang=js"
import style0 from "./ThinkFarm.vue?vue&type=style&index=0&id=07c15748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c15748",
  null
  
)

export default component.exports